import React, { Component } from "react";
import { Link } from "react-router-dom";

// Layout
import Header from "../layout/header/header1";

// Images
import bannerImg from "../../images/banner/banner3.jpg";
import news25_1 from "../../images/news/news25_1.jpg";
import news25_2 from "../../images/news/news25_2.jpg";
import news25_3 from "../../images/news/news25_3.jpg";
import news25_4 from "../../images/news/news25_4.jpg";
import news25_5 from "../../images/news/news25_5.jpg";
import news25_6 from "../../images/news/news25_6.jpg";
import news25_7 from "../../images/news/news25_7.jpg";
import news25_8 from "../../images/news/news25_8.jpg";

import { withTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";


class news25 extends Component {
    componentDidMount() { }

    componentWillMount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("News25_Title");
    }

    componentWillUnmount() {
        const { t } = this.props;
        document.getElementById("title").innerText = t("Home_Title");
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Header />

                <div className="page-content">
                    <div
                        className="page-banner ovbl-dark"
                        style={{ backgroundImage: "url(" + bannerImg + ")" }}
                    >
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">{t("News25_Title")}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="breadcrumb-row">
                        <div className="container">
                            <ul className="list-inline">
                                <li>
                                    <Link to="/">{t("News25_LinkHome")}</Link>
                                </li>
                                <li>{t("News25_LinkCourses")}</li>
                            </ul>
                        </div>
                    </div>

                    <div className="content-block">
                        <div className="section-area section-sp1">
                            <div className="container">
                                <div className="row d-flex flex-row-reverse">
                                    <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
                                        <div className="courses-post">

                                            <h1>{t("News25_Content_H")}</h1>


                                            {/* P1 */}
                                            <ReactMarkdown>{t("News25_P1_MD")}</ReactMarkdown>


                                            {/* Video 1 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID1_DESC")}
                                                        src="https://youtube.com/embed/5-W_PCLGrqg?si=hU05en8RmgHiFFre"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_VID1_DESC")}
                                                </div>
                                            </div>

                                            {/* P2 */}
                                            <ReactMarkdown>{t("News25_P2_MD")}</ReactMarkdown>


                                            {/* IMG 1 & IMG 2*/}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div style={{ display: "flex", justifyContent: "center", gap: 0, flexWrap: "wrap" }}>
                                                    <img
                                                        src={news25_1}
                                                        alt={t("News25_IMG2_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                    <img
                                                        src={news25_2}
                                                        alt={t("News25_IMG3_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}

                                                    />
                                                </div>

                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_IMG3_DESC")}
                                                </div>
                                            </div>



                                            {/* P4 */}
                                            <ReactMarkdown>{t("News25_P4_MD")}</ReactMarkdown>

                                            {/* Video 2 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID2_DESC")}
                                                        src="https://youtube.com/embed/pB0T2g2mMiE?si=M1l0DaZ9z0Bd5I20"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_VID2_DESC")}
                                                </div>
                                            </div>

                                            {/* P5 */}
                                            <ReactMarkdown>{t("News25_P5_MD")}</ReactMarkdown>

                                            {/* P6 */}
                                            <ReactMarkdown>{t("News25_P6_MD")}</ReactMarkdown>

                                            {/* Video 3 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID3_DESC")}
                                                        src="https://youtube.com/embed/kkYt_jU0qZQ?si=8VLjYfn6AkCxHPOH"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_VID3_DESC")}
                                                </div>
                                            </div>

                                            {/* P7 */}
                                            <ReactMarkdown>{t("News25_P7_MD")}</ReactMarkdown>

                                            {/* Video 4 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID4_DESC")}
                                                        src="https://youtube.com/embed/4p2QlfnuDEc?si=I58fIiZs4ZSZHdzk"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_VID4_DESC")}
                                                </div>
                                            </div>

                                            {/* P8 */}
                                            <ReactMarkdown>{t("News25_P8_MD")}</ReactMarkdown>

                                            {/* IMG 3 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news25_3}
                                                    alt={t("News25_IMG4_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_IMG4_DESC")}
                                                </div>
                                            </div>

                                            {/* P9 */}
                                            <ReactMarkdown>{t("News25_P9_MD")}</ReactMarkdown>

                                            {/* IMG 4 & IMG 5*/}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div style={{ display: "flex", justifyContent: "center", gap: 0, flexWrap: "wrap" }}>
                                                    <img
                                                        src={news25_4}
                                                        alt={t("News25_IMG5_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}
                                                    />
                                                    <img
                                                        src={news25_5}
                                                        alt={t("News25_IMG6_DESC")}
                                                        style={{ maxWidth: "50%", height: "auto" }}

                                                    />
                                                </div>

                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_IMG5_DESC")}
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_IMG6_DESC")}
                                                </div>
                                            </div>

                                            {/* P10 */}
                                            <ReactMarkdown>{t("News25_P10_MD")}</ReactMarkdown>

                                            {/* Video 5 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID5_DESC")}
                                                        src="https://youtube.com/embed/uoYw4PAajAg?si=1Oo9q8WApst29RWv"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_VID5_DESC")}
                                                </div>
                                            </div>

                                            {/* P11 */}
                                            <ReactMarkdown>{t("News25_P11_MD")}</ReactMarkdown>

                                            {/* IMG 6 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news25_6}
                                                    alt={t("News25_IMG7_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_IMG7_DESC")}
                                                </div>
                                            </div>

                                            {/* P12 */}
                                            <ReactMarkdown>{t("News25_P12_MD")}</ReactMarkdown>

                                            {/* IMG 7 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news25_7}
                                                    alt={t("News25_IMG8_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_IMG8_DESC")}
                                                </div>
                                            </div>

                                            {/* P13 */}
                                            <ReactMarkdown>{t("News25_P13_MD")}</ReactMarkdown>

                                            {/* Video 6 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID6_DESC")}
                                                        src="https://youtube.com/embed/GnEqnFGWWRo?si=r1LEz33SMcUI9_xl"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_VID6_DESC")}
                                                </div>
                                            </div>

                                            {/* P14 */}
                                            <ReactMarkdown>{t("News25_P14_MD")}</ReactMarkdown>

                                            {/* IMG 8 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <img
                                                    src={news25_8}
                                                    alt={t("News12_IMG9_DESC")}
                                                />
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_IMG9_DESC")}
                                                </div>
                                            </div>

                                            {/* P15 */}
                                            <ReactMarkdown>{t("News25_P15_MD")}</ReactMarkdown>

                                            {/* Video 7 */}
                                            <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        width: "100%",
                                                        paddingBottom: "56.25%",
                                                        height: 0,
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <iframe
                                                        style={{
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            border: 0,
                                                        }}
                                                        title={t("News12_VID7_DESC")}
                                                        src="https://youtube.com/embed/vXNbTyJf6Xg?si=fpeGHJnLjL73kpL4"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                                <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                    {t("News25_VID7_DESC")}
                                                </div>
                                            </div>

                                            {/* P16 */}
                                            <ReactMarkdown>{t("News25_P16_MD")}</ReactMarkdown>

                                            {/* Video 8 (Chinese page only) */}
                                            {this.props.i18n.language === "zh" && (
                                                <div style={{ textAlign: "center", margin: "11px 0" }}>
                                                    <div
                                                        style={{
                                                            position: "relative",
                                                            width: "100%",
                                                            paddingBottom: "56.25%",
                                                            height: 0,
                                                            overflow: "hidden",
                                                        }}
                                                    >
                                                        <iframe
                                                            style={{
                                                                position: "absolute",
                                                                top: 0,
                                                                left: 0,
                                                                width: "100%",
                                                                height: "100%",
                                                                border: 0,
                                                            }}
                                                            title={t("News25_VID8_DESC")}
                                                            src="https://youtube.com/embed/eUrp8iDweVg?si=f6YqAM8SrfmC4Bw7"
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                            allowFullScreen
                                                        ></iframe>
                                                    </div>
                                                    <div style={{ marginTop: "10px", fontStyle: "italic", color: "#555" }}>
                                                        {t("News25_VID8_DESC")}
                                                    </div>
                                                </div>
                                            )}


                                            {/* P17 */}
                                            <ReactMarkdown>{t("News25_P17_MD")}</ReactMarkdown>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </>

        );
    }
}

export default news25 = withTranslation()(news25);
